import React, { useEffect, useState, useRef, useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { setBreadcrumbItems } from "../../store/actions"
import Doctordropdown from "./Doctordropdown"
import { fetchLeaveDays } from "../../store/clinicSetting/action"

import tippy from "tippy.js"
import "tippy.js/dist/tippy.css"
import "../Calendar/calender.scss"
import { toast } from "react-toastify"

import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"

import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"

import timeGridPlugin from "@fullcalendar/timegrid"
import BootstrapTheme from "@fullcalendar/bootstrap"
import listPlugin from "@fullcalendar/list"

import { addNewEvent, getCategories, getEvents } from "../../store/actions"
import DeleteModal from "./DeleteModal"
import API from "../../api/axios"
import BookingModal from "./DoctorBookingModel"

const Calender = props => {
  document.title = "Calendar | Lexa - Responsive Bootstrap 5 Admin Dashboard"

  const [setCalenderView, updatedCalenderView] = useState("dayGridMonth")
  const [modal, setModal] = useState(false)

  const [modalcategory, setModalcategory] = useState(false)

  const [selectedDay, setSelectedDay] = useState(0)

  const [events, setEvents] = useState([])

  // const [showEditModal, setShowEditModal] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState(null)

  const [selectedDoctor, setSelectedDoctor] = useState("")
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null)
  const [bookingModal, setBookingModal] = useState(false)
  const [recentActivities, setRecentActivities] = useState([])

  // Fetch clinic settings on mount
  const dispatch = useDispatch()
  const leaveDaysList = useSelector(state =>
    Array.isArray(state?.clinicSetting?.leaveDays)
      ? state.clinicSetting.leaveDays
      : [],
  )

  const generateClinicClosed = useCallback(() => {
    console.log("hello this is called")
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()

    const clinicClosed = []

    const dayMap = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
    }

    const closedDayNumbers = leaveDaysList.map(day => dayMap[day.toLowerCase()])
    console.log({ closedDayNumbers })
    for (let day = 1; day <= 31; day++) {
      const date = new Date(year, month, day)
      if (date.getMonth() !== month) break

      if (closedDayNumbers.includes(date.getDay())) {
        clinicClosed.push({
          id: `clinic-closed-${day}`,
          title: "Clinic Closed",
          start: date.toLocaleDateString("en-CA"),
          display: "background",
          color: "#FF0000",
        })
      }
    }

    console.log("😁clinic closed events", clinicClosed)

    setEvents(prevEvents => {
      const filtered = prevEvents.filter(
        e =>
          !String(e.id).startsWith("clinic-closed-") &&
          !String(e.id).startsWith("fully-blocked"),
      )
      return [...filtered, ...clinicClosed]
    })
  }, [leaveDaysList])

  useEffect(() => {
    // console.log("📆 leaveDaysList:", leaveDaysList)

    dispatch(fetchLeaveDays())
  }, [dispatch])
  useEffect(() => {
    if (leaveDaysList.length > 0) {
      generateClinicClosed()
    }
  }, [leaveDaysList, generateClinicClosed])

  // this open when user select the time range

  const handleDateSelect = selectInfo => {
    const clickedDate = new Date(selectInfo.startStr)
    const clickedDateStr = clickedDate.toISOString().split("T")[0]

    const isOnLeave = events.some(event => {
      return (
        event.display === "background" &&
        event.id?.startsWith("doctor-leave-") &&
        event.start === clickedDateStr
      )
    })

    if (isOnLeave) {
      toast.warning(" selected doctor is on leave on this day.")
      return
    }

    const isClinicClosed = events.some(event => {
      return (
        event.display === "background" &&
        event.id?.startsWith("clinic-closed") &&
        event.start === clickedDateStr
      )
    })

    if (isClinicClosed) {
      toast.warning("clinic is closed on this day.")
      return
    }

    // Existing time slot unavailable check (blocked hours, etc.)
    const isUnavailable = events.some(event => {
      if (event.display !== "background") return false

      const eventStart = new Date(event.start)
      const eventEnd = event.end ? new Date(event.end) : new Date(event.start)

      const slotStart = new Date(selectInfo.startStr)
      const slotEnd = new Date(selectInfo.endStr)

      // Handle full-day blocking
      const isAllDay = eventStart.getHours() === 0 && eventEnd.getHours() === 0

      if (isAllDay) return false

      return slotStart < eventEnd && slotEnd > eventStart
    })

    if (isUnavailable) {
      toast.warning("This time slot is unavailable")

      return
    }

    // If everything is OK, set the selected time slot
    setSelectedTimeSlot({
      start: selectInfo.startStr,
      end: selectInfo.endStr,
    })

    setBookingModal(true)
  }

  // this open the model in edit mode when user click on event
  const handleEventClick = clickInfo => {
    const event = clickInfo.event
    const extended = event.extendedProps

    const appointmentData = {
      id: event.id,
      title: event.title,
      patientId: extended.patientId,
      serviceId: extended.serviceId,
      patientName: extended.patientName,
      statusId: extended.statusId,
      appointmentStartTime: event.start,
      appointmentEndTime: event.end,
    }

    setBookingModal(false)
    // setSelectedEvent(null) // reset current selectedEvent

    setTimeout(() => {
      setSelectedEvent({ ...appointmentData }) // force new object reference
      setBookingModal(true) // now open the modal
    }, 0)
  }

  const handleEventChange = changeInfo => {
    const { id, start, end } = changeInfo.event
    setEvents(prev =>
      prev.map(event =>
        event.id === id
          ? { ...event, start: start.toISOString(), end: end?.toISOString() }
          : event,
      ),
    )
  }

  //
  const blockUnavailableTimeSlot = availability => {
    const today = new Date()
    const startOfWeek = new Date(
      today.setDate(today.getDate() - today.getDay()),
    )

    const weekdayMap = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
    }

    const closedDaysLower = leaveDaysList.map(d => d.toLowerCase())

    const formatted = []

    for (let week = 0; week < 4; week++) {
      Object.entries(weekdayMap).forEach(([day, dayIndex]) => {
        const slotDate = new Date(startOfWeek)
        slotDate.setDate(startOfWeek.getDate() + dayIndex + week * 7)

        const dateStr = slotDate.toISOString().split("T")[0]

        if (closedDaysLower.includes(day)) return

        const availableSlot = availability.find(
          a => a.day.toLowerCase() === day && a.available,
        )

        if (availableSlot?.starttime && availableSlot?.endtime) {
          // Block before available time
          formatted.push({
            id: `block-before-${week}-${day}-${availableSlot.starttime}`,

            start: `${dateStr}T00:00:00`,
            end: `${dateStr}T${availableSlot.starttime}`,
            display: "background",
            color: "#797676",
          })

          // Block after available time
          formatted.push({
            id: `block-after-${week}-${day}`,
            start: `${dateStr}T${availableSlot.endtime}`,
            end: `${dateStr}T23:59:59`,
            display: "background",
            color: "#797676",
          })
        } else {
          // Block full day but NOT if clinic is closed
          formatted.push({
            id: `fully-blocked-${week}-${day}`,
            start: `${dateStr}T00:00:00`,
            end: `${dateStr}T23:59:59`,
            display: "background",
            color: "#797676",
          })
        }
      })
    }

    setEvents(prevEvents => {
      const filtered = prevEvents.filter(
        e =>
          !String(e.id).startsWith("block-") &&
          !(
            String(e.id).startsWith("fully-blocked") &&
            !String(e.id).startsWith("clinic-closed")
          ),
      )
      return [...filtered, ...formatted]
    })
  }

  const fetchDoctorLeaves = async doctorId => {
    try {
      const authToken = localStorage.getItem("authToken")

      const response = await API.get(
        `/leaves/${doctorId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )
      // console.log("fetchdoctorleaves.....", response.data)

      const data = response?.data
      return Array.isArray(data) ? data : []
    } catch (error) {
      console.error("Error fetching doctor leaves", error)
      return []
    }
  }

  useEffect(() => {
    if (!selectedDoctor) return
    fetchAppointments(selectedDoctor)
    loadDoctorLeaves(selectedDoctor)
  }, [selectedDoctor])

  const loadDoctorLeaves = async doctorId => {
    const leavePeriods = await fetchDoctorLeaves(doctorId)
    if (!Array.isArray(leavePeriods)) return

    // First: collect all clinic closed days from current events
    const clinicClosedDates = new Set(
      events
        .filter(event => event.id?.startsWith("clinic-closed"))
        .map(event => event.start),
    )

    const leaveEvents = []

    leavePeriods.forEach((leave, index) => {
      const startDate = new Date(leave.leave_startDate)
      const endDate = new Date(leave.leave_endDate)
      endDate.setDate(endDate.getDate() + 1)

      let current = new Date(startDate)

      while (current < endDate) {
        const dateStr = current.toISOString().split("T")[0]

        if (!clinicClosedDates.has(dateStr)) {
          leaveEvents.push({
            id: `doctor-leave-${index}-${dateStr}`,
            title: "Doctor On Leave",
            start: dateStr,
            end: dateStr,
            display: "background",
            color: "#FFA500",
          })
        }

        current.setDate(current.getDate() + 1)
      }
    })

    setEvents(prev => {
      const filtered = prev.filter(
        e => !String(e.id).startsWith("doctor-leave-"),
      )
      return [...filtered, ...leaveEvents]
    })
  }

  const fetchAppointments = async doctorId => {
    try {
      // console.log("Fetching appointments for doctor:", doctorId)
      if (!doctorId) return
      // console.log("doctorId", doctorId)
      const authToken = localStorage.getItem("authToken")
      const res = await API.get(
        `/appointments/doctor/${doctorId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )
      // console.log("doctor appointment....", res.data)

      const appointments = (
        Array.isArray(res.data) ? res.data : [res.data]
      ).map(appt => {
        const fname = appt.Patient?.fname || ""
        const lname = appt.Patient?.lname || ""
        const fullName = `${fname} ${lname}`.trim()

        return {
          id: `${appt.id}`,
          title: fullName || "Patient",
          start: new Date(appt.appointmentStartTime),
          end: new Date(appt.appointmentEndTime),
          color:
            appt.StatusList?.name?.toLowerCase() === "cancelled"
              ? "#FF4D4F"
              : "#3788d8",

          allDay: false,
          extendedProps: {
            patientId: appt.Patient?.id,
            patientName: fullName,
            serviceId: appt.serviceId,
            statusId: appt.statusId || null, // include statusId
            statusName: appt.StatusList?.name || "", //  optionally include status name
            fullData: appt, //  optionally pass full object if needed
            eventType: "appointment",
          },
        }
      })

      // Set recent activities
      setRecentActivities(
        appointments.map(appt => ({
          date: new Date(appt.start).toLocaleDateString(),
          text: `Appointment with ${appt.title} at ${new Date(
            appt.start,
          ).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}`,
        })),
      )

      setEvents(prev => {
        const cleaned = prev.filter(
          e => e.extendedProps?.eventType !== "appointment",
        )
        return [...cleaned, ...appointments]
      })
    } catch (err) {
      console.error("Error fetching appointments", err)
    }
  }

  const calendarRef = useRef()

  //  Handling the modal state

  const toggle = () => {
    setModal(!modal)
  }

  // Handling date click on calendar

  const handleDateClick = arg => {
    setSelectedDay(arg)
    toggle()
  }

  const handleValidEventSubmitcategory = values => {
    const { onAddNewEvent } = props

    const newEvent = {
      id: Math.floor(Math.random() * 100),
      title: values["title_category"],
      start: selectedDay ? selectedDay.date : new Date(),
      className: values.event_category + " text-white",
    }
    // save new event

    onAddNewEvent(newEvent)
    toggleCategory()
  }

  const getInitialView = () => {
    if (window.innerWidth >= 768 && window.innerWidth < 1200) {
      updatedCalenderView("dayGridWeek")
    } else if (window.innerWidth <= 768) {
      updatedCalenderView("listWeek")
    } else {
      updatedCalenderView("dayGridMonth")
    }
  }

  //BreadCrumd add
  const breadcrumbItems = [
    { title: "Home", link: "#" },
    { title: "Calendar", link: "#" },
  ]

  useEffect(() => {
    props.onSetBreadCrumbs("Calendar", breadcrumbItems)
  })

  const handleEventCreateSuccess = newEvent => {
    fetchAppointments(selectedDoctor)
    setBookingModal(false)
  }
  const appointmentsOnly = events.filter(
    e => e.extendedProps?.eventType === "appointment",
  )

  return (
    <React.Fragment>
      <Row className="mb-4">
        <Col xl={3}>
          <Card>
            <label style={{ marginRight: "8px" }}></label>
            <Doctordropdown
              selectedDoctorId={selectedDoctor}
              onselect={setSelectedDoctor}
              onDoctorAvailabilityChange={blockUnavailableTimeSlot}
            />
            <CardBody className="d-grid">
              <div className="d-grid"></div>
              <Col md={8} className="text-end">
                <Button
                  style={{ backgroundColor: "#d1cbc2" }}
                  className="me-2 mt-4 "
                >
                  Not Available Doctor
                </Button>
                <Button
                  style={{ backgroundColor: "#FFE4B2", color: "black" }}
                  className="me-2 mt-4 "
                >
                  Doctor on Leave
                </Button>
                <Button
                  style={{ backgroundColor: "#FFB2B2" }}
                  className="me-2 mt-4"
                >
                  Clinic Closed
                </Button>
              </Col>
              {/* <div className="mt-5">
                <h5 className="font-size-14 mb-4">Recent appointments:</h5>

                <ul className="list-unstyled activity-feed ms-1">
                  {recentActivities.length > 0 ? (
                    recentActivities.map((activity, index) => (
                      <li className="feed-item" key={index}>
                        <div className="feed-item-list">
                          <div>
                            <div className="date">{activity.date}</div>
                            <p className="activity-text mb-0">
                              {activity.text}
                            </p>
                          </div>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <div>
                          <div className="date">-</div>
                          <p className="activity-text mb-0">
                            No recent appointments.
                          </p>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div> */}
            </CardBody>
          </Card>
        </Col>
        <Col className="col-xl-9">
          <div className="card mt-4 mt-xl-0 mb-0">
            <div className="card-body">
              <div
                style={{
                  marginBottom: "1rem",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              ></div>
              {/* fullcalendar control  */}

              <FullCalendar
                plugins={[
                  BootstrapTheme,
                  dayGridPlugin,
                  interactionPlugin,
                  listPlugin,
                  timeGridPlugin,
                ]}
                eventDidMount={info => {
                  const eventType = info.event.extendedProps.eventType

                  if (eventType === "appointment") {
                    const patient = info.event.title
                    const start = new Date(info.event.start).toLocaleTimeString(
                      [],
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      },
                    )
                    const end = new Date(info.event.end).toLocaleTimeString(
                      [],
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      },
                    )

                    tippy(info.el, {
                      content: `Name: ${patient}<br>StartTime: ${start}<br>EndTime: ${end}`,
                      allowHTML: true,
                      theme: "purple-tooltip",
                      interactive: false,
                    })
                  }
                }}
                initialView="timeGridWeek"
                height={"90vh"}
                handleWindowResize={true}
                themeSystem="bootstrap"
                headerToolbar={{
                  start: "today prev,next",
                  center: "title",
                  end: "dayGridMonth,timeGridWeek,timeGridDay,agendaView",
                }}
                views={{
                  agendaView: {
                    type: "listWeek",
                    buttonText: "Agenda",
                  },
                }}
                allDaySlot={true}
                events={events}
                editable={true}
                droppable={true}
                selectable={true}
                dayMaxEvents={true}
                weekends={true}
                selectMirror={true}
                dateClick={handleDateClick}
                eventClick={handleEventClick}
                select={handleDateSelect}
                eventChange={handleEventChange}
                slotDuration="00:05:00"
                snapDuration="00:05:00"
                slotLabelInterval="00:15:00"
                slotMinTime="08:00:00"
                slotMaxTime="23:00:00"
                ref={calendarRef}
                windowResize={getInitialView}
                timeZone="local"
              />

              <BookingModal
                key={selectedEvent?.id || selectedTimeSlot?.start || "new"}
                isOpen={bookingModal}
                toggle={() => {
                  setBookingModal(false)
                  setSelectedEvent(null)
                  setSelectedTimeSlot(null)
                }}
                timeSlot={selectedTimeSlot}
                onSuccess={handleEventCreateSuccess}
                doctorId={selectedDoctor}
                appointment={selectedEvent}
                appointments={appointmentsOnly}
                events={events}
              />
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

Calender.propTypes = {
  events: PropTypes.array,
  categories: PropTypes.array,
  className: PropTypes.string,

  c: PropTypes.func,
  onSetBreadCrumbs: PropTypes.func,
}

const mapStateToProps = ({ calendar }) => ({
  events: calendar.events,
  categories: calendar.categories,
})

const mapDispatchToProps = dispatch => ({
  onGetEvents: () => dispatch(getEvents()),
  onGetCategories: () => dispatch(getCategories()),
  onAddNewEvent: event => dispatch(addNewEvent(event)),

  onSetBreadCrumbs: (title, breadcrumbItems) =>
    dispatch(setBreadcrumbItems(title, breadcrumbItems)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Calender)
